export default (source, key) => {
  const copySource = [...source];

  copySource.sort((a, b) => {
    if (new Date(a[key]).getTime() > new Date(b[key]).getTime()) {
      return -1;
    }

    if (new Date(a[key]).getTime() < new Date(b[key]).getTime()) {
      return 1;
    }

    return 0;
  });

  return copySource;
};
